
import { Component, Vue } from 'vue-property-decorator';
import { CommonStore, ConfigurationStore } from '@/store/modules';

import SvgIcon from '@/components/SvgIcon.vue';
import { QTablePagination } from '@/store/models/meta';
import helpers from '@/utils/helpers';

import { colors } from 'quasar';
import {
  CropSeasonCalendar,
  SeasonCalendar
} from '@/store/models/configuration';
const { getPaletteColor } = colors;

@Component({
  components: {
    SvgIcon
  }
})
export default class Seasonist extends Vue {
  season: SeasonCalendar | null = null;

  deleteDialog = false;
  loading = false;
  filter = '';

  tableColumn = [
    {
      name: 'crop_type__name',
      label: 'Crop',
      field: (row: CropSeasonCalendar) => row.cropName,
      sortable: true,
      align: 'left'
    },
    {
      name: 'crop_variety__name',
      label: 'Crop Variety',
      field: (row: CropSeasonCalendar) => row.cropVarietyName,
      sortable: true,
      align: 'left'
    },
    {
      name: 'start_date',
      label: 'Start Date',
      field: (row: CropSeasonCalendar) => {
        if (row.seasonCalendar && row.seasonCalendar != null) {
          return `${row.seasonCalendar.startMonth
            .toString()
            .padStart(
              2,
              '0'
            )}-${row.seasonCalendar.startDay.toString().padStart(2, '0')}`;
        } else {
          return '';
        }
      },
      sortable: true,
      align: 'left'
    },
    {
      name: 'end_date',
      label: 'End Date',
      field: (row: CropSeasonCalendar) => {
        if (row.seasonCalendar && row.seasonCalendar != null) {
          return `${row.seasonCalendar.endMonth
            .toString()
            .padStart(2, '0')}-${row.seasonCalendar.endDay
            .toString()
            .padStart(2, '0')}`;
        } else {
          return '';
        }
      },
      sortable: true,
      align: 'left'
    },
    {
      name: 'actions',
      label: 'Actions',
      align: 'left',
      style: 'width: 100px;'
    }
  ];
  get currentFarm() {
    return CommonStore.SelectedFarmBlock;
  }
  get seasons() {
    return ConfigurationStore.PaginatedSeasonCalendar;
  }

  get seasonPagination() {
    return ConfigurationStore.SeasonTablePagination;
  }

  set seasonPagination(data: QTablePagination) {
    ConfigurationStore.setSeasonTablePagination(data);
  }

  //eslint-disable-next-line
  async onRequest(props: any) {
    const { page, rowsPerPage, sortBy, descending } = props.pagination;
    const filter = props.filter;
    this.loading = true;

    const ordering = `${descending ? '-' : ''}${sortBy}`;

    const queryParams = {
      page: page,
      search: filter,
      ordering: ordering,
      pageSize: rowsPerPage,
      farm: this.currentFarm.farmId
    };
    await ConfigurationStore.getSeasonCalendars(queryParams);
    this.loading = false;

    this.seasonPagination = {
      page: this.seasons.currentPage,
      rowsPerPage: this.seasons.pageSize,
      rowsNumber: this.seasons.totalObjects,
      sortBy: sortBy,
      descending: descending
    };
  }

  getPaletteColor(colorName: string) {
    return getPaletteColor(colorName);
  }

  async onDelete(seasonId: number) {
    this.deleteDialog = false;
    if (seasonId != 0) {
      ConfigurationStore.deleteSeasonCalendar(seasonId);
    }
  }

  deleteSeason(season: CropSeasonCalendar) {
    this.season = season.seasonCalendar;
    this.deleteDialog = true;
  }

  defineSeason(cropSeason: CropSeasonCalendar) {
    if (
      cropSeason &&
      cropSeason.seasonCalendar &&
      cropSeason.seasonCalendar != null
    ) {
      this.season = cropSeason.seasonCalendar;
      ConfigurationStore.setAddEditSeasonCalendar(this.season);
      this.$router.push({
        name: 'EditSeason',
        params: {
          seasonId: `${this.season.id}`,
          cropId: `${cropSeason.id}`
        }
      });
    } else {
      this.$router.push({
        name: 'AddSeason',
        params: {
          cropId: `${cropSeason.id}`
        }
      });
    }
  }

  async created() {
    this.loading = true;
    await helpers.fetchingDefaultFarm();
    this.onRequest({
      pagination: this.seasonPagination,
      filter: this.filter
    });
    this.loading = false;
  }
}
